import { FC } from 'react'
import { EmpresaForm } from '../form/EmpresaForm'

export const EmpresaEditModalForm: FC = () => {
  return <EmpresaForm mode='empresa' />
}
